export const viagensRoute: string = 'viagens';
export const viagensModuleName: any = {plural: 'Deslocamentos', single: 'Deslocamento'};


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/shared/data.service.ts
 **/